module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sagitta/sge_oc-557fc6ac2a06bf3f15484aae2ddcce5a.gif";